import React, { useEffect, useRef, useState } from "react";

const Box = () => {
  const sectionRef = useRef(null);
  const [boxes, setBoxes] = useState([]);

  // 🔹 Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && sectionRef.current) {
          sectionRef.current.classList.add("in-view");
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // 🔹 JSON + XML
  useEffect(() => {
    // ✅ JSON → UI
    fetch("/api/boxes.json")
      .then(res => res.json())
      .then(data => {
        console.log("BOXES JSON:", data);
        setBoxes(data?.boxes || []); // 🔥 SAFE
      })
      .catch(err => console.error("BOXES JSON ERROR:", err));

    // ✅ XML → exam / proof
    fetch("/api/boxes.xml")
      .then(res => res.text())
      .then(() => console.log("Boxes XML loaded"))
      .catch(err => console.error("BOXES XML ERROR:", err));
  }, []);

  return (
    <>
      {/* ✅ SECTION ALWAYS RENDERED */}
      <section className="info-boxes" ref={sectionRef}>

        {/* 🔹 OPTIONAL LOADER */}
        {boxes.length === 0 && (
          <div style={{ gridColumn: "1 / -1", padding: "40px", color: "#000" }}>
            Loading...
          </div>
        )}

        {boxes.map((box, index) => (
          <div
            key={index}
            className={`box ${box.bgClass} ${box.animationClass}`}
          >
            <div className="icon">
              <img src={box.icon} alt={box.title} />
            </div>

            <h3>{box.title}</h3>

            {box.subtitle && (
              <div className="sub">{box.subtitle}</div>
            )}

            <p>{box.description}</p>
          </div>
        ))}
      </section>


      <style>{`
/* ================= INFO BOXES ================= */

.info-boxes {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  text-align: center;
  color: white;
}

/* BOX */
.box {
  position: relative;
  min-height: 200px;
  padding-top: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  opacity: 0;
}

/* ENTRY POSITIONS */
.box-left {
  transform: translateX(-80px);
}

.box-center {
  transform: translateY(60px);
}

.box-right {
  transform: translateX(80px);
}

/* ACTIVE */
.info-boxes.in-view .box {
  opacity: 1;
  transform: translateX(0) translateY(0);
  transition: all 0.9s ease;
}

/* BACKGROUND + OVERLAY */
.box::before {
  content: "";
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transition: transform 0.8s ease;
  z-index: -1;
}

/* HOVER EFFECT */
.box:hover {
  transform: translateY(-5px) scale(1.03);
  box-shadow: 0 12px 25px rgba(0,0,0,0.25);
}

.box:hover::before {
  transform: scale(1.1);
}

.box-image {
  width: 90px;
  height: 90px;
  object-fit: contain;
  margin: 10px auto 15px;
  display: block;
  transition: transform 0.4s ease;
}

.box:hover .box-image {
  transform: scale(1.12) rotate(2deg);
}

/* ICON */
.box .icon {
  width: 80px;
  height: 80px;
  background: #fff;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box .icon img {
  width: 45px;
  height: 45px;
}

/* ROTATION */
.box:hover .icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* TEXT */
.box h3 {
  font-size: 27px;
  font-weight: 600;
  font-family: var(--primary-font-family);
  margin-bottom: 6px;
  color: #000;
}

.sub {
  font-size: 13px;
  margin: 0;
  font-family: var(--primary-font-family);
}

.box p {
  font-size: 16px;
  max-width: 316px;
  margin: 0 auto;
  font-family: var(--secondary-font-family);
  color: #000;
}

/* COLORS */
.green::before {
  background-image:
    linear-gradient(rgba(108,190,69,.85), rgba(108,190,69,.87)),
    url("/assets/box/4.jpg");
}

.blue::before {
  background-image:
    linear-gradient(rgba(86,165,196,.85), rgba(86,165,196,.87)),
    url("/assets/box/5.jpg");
}

.pink::before {
  background-image:
    linear-gradient(rgba(221,48,116,.85), rgba(221,48,116,.87)),
    url("/assets/box/6.jpg");
}

/* RESPONSIVE */
@media (max-width: 992px) {
  .info-boxes {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .info-boxes {
    grid-template-columns: 1fr;
  }
}
      `}</style>
    </>
  );
};

export default Box;
